/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class Record
{
  static getInitialState (cass)
  {
    return Object.freeze(cass);
  }


  constructor (cursor)
  {
    this.cursor = cursor;
  }


  load (cass)
  {
    this.cursor.set(this.constructor.getInitialState(cass));
  }


  unload ()
  {
    this.cursor.remove();
  }


  get cass ()
  {
    return this.cursor.get();
  }


  equals (other)
  {
    return other?.constructor === this.constructor && this.cursor.get() === other.cursor.get();
  }


};
